/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "837b10b6eea6e327fe48daf6c2b05eef57a56dcb";
